export const SCREENS = {
    PLAY_SCREEN: "play",
    CREATE_GAME: "create_game",
    CHOOSE: "choose"
};
